export const workItemListEventRoutes = {
  composeEmailRemoved: 'workItemListEventRoute-composeEmailRemoved'
};

Object.freeze(workItemListEventRoutes);
